<template>
  <div class="">

  </div>
</template>

<script>

export default {
    data() {
        return{
            loading: false
        }
    },
    methods: {
        sampleFunction() {
            //
        }
    },
    mounted() {
        //
    }
}
</script>
<style lang="scss">

</style>
